__turbopack_context__.v({
  "expandedContent": "ExpandedContent-module__hWguDq__expandedContent",
  "expandedContentAccent": "ExpandedContent-module__hWguDq__expandedContentAccent",
  "expandedContentCritical": "ExpandedContent-module__hWguDq__expandedContentCritical",
  "expandedContentDefault": "ExpandedContent-module__hWguDq__expandedContentDefault",
  "expandedContentInner": "ExpandedContent-module__hWguDq__expandedContentInner",
});
